<template>
  <div class="view-bg">
    <div class="box-area invite-records">
      <div
        class="d-flex justify-content-center flex-column empty-content"
        v-if="!inviteRecords.length"
      >
        <p v-if="isLoading">加载中……</p>
        <template v-else>
          <p>暂无邀请记录</p>
          <p>快去邀请好友赚钱吧～</p>
        </template>
      </div>
      <ul v-else>
        <li v-for="item in inviteRecords" :key="item.id">
          <div class="d-flex">
            <div class="d-flex justify-content-start u-info">
              <img :src="item.referred_user.avatar" />
              <div class="d-flex justify-content-center flex-column">
                <b class="u-info__number">{{ item.referred_user.mobile }}</b
                ><time>{{ item.created_at }}</time>
              </div>
            </div>
            <div class="d-flex flex-column justify-content-center u-logined">
              <template v-if="item.is_sign_in">
                已登录<b class="special-color"
                  >+{{ item.give_golds || 0 }}金币</b
                >
              </template>
              <template v-else>
                <span class="gray-yellow-color">未登录</span
                ><b class="gray-yellow-color">-</b>
              </template>
            </div>
            <div class="d-flex flex-column justify-content-center u-vip">
              <template v-if="item.is_open_vip">
                <span>已开通VIP</span>
                <b class="special-color">+{{ item.commissions }}元</b>
              </template>
              <template v-else>
                <span class="gray-yellow-color">未开通VIP</span
                ><b class="gray-yellow-color">-</b>
              </template>
            </div>
          </div>
          <p
            v-if="item.state_tip"
            class="u-state waiting-icon"
            :class="{ 'invalid-icon': item.live_vip_is_closed }"
          >
            {{ item.state_tip }}
          </p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import "@/utils/flexible";
import * as utils from "@/utils/index";
import * as Api from "@/api/activity/inviteCashBack.js";

export default {
  name: "inviteRecords",
  data() {
    return {
      isLoading: true,
      inviteRecords: [],
      token: this.$route.params.token,
      userID: this.$route.params.userID,
      lastRecordId: 0,
    };
  },
  created() {
    // 获取活动邀请记录
    this.getInviteRecords();
  },
  mounted() {
    window.onscroll = () => {
      //变量scrollTop是滚动条滚动时，距离顶部的距离
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      //变量windowHeight是可视区的高度
      let windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      //变量scrollHeight是滚动条的总高度
      let scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      //滚动条到底部的条件
      if (scrollTop + windowHeight == scrollHeight) {
        //到了这个就可以进行业务逻辑加载后台数据了
        if(!this.isLoading){
          this.getInviteRecords();
        }
      }
    };
  },
  methods: {
    getInviteRecords() {
      Api.records({
        token: this.token,
        params: {
          user_id: this.userID,
          limits: 20,
          last_record_id: this.lastRecordId,
        },
      })
        .then((res) => {
          utils.logic(res, (data) => {
            if (data.length) {
              this.inviteRecords.push(...data);
              this.lastRecordId = data[data.length - 1].id;
            }
            this.isLoading = false;
          });
        })
        .catch((err) => {
          this.$message.error("系统错误");
          throw Error(err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/sass/global.scss";

.view-bg {
  background: linear-gradient(to right, #ff7130, #ff9c29);
  user-select: none;
  min-height: 100vh;
  padding-top: rem(40px);
  padding-bottom: rem(1px);
  box-sizing: border-box;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  b {
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
  }
}

.box-area {
  position: relative;
  width: rem(690px);
  margin: 0 auto rem(66px);
  border: rem(8px) solid #fda906;
  border-radius: rem(20px);
  box-sizing: border-box;
  background-color: #fff2e3;
}

.invite-records {
  padding-top: rem(39px);
  .empty-content {
    height: rem(226px);
    text-align: center;
    p {
      margin-bottom: rem(20px);
      color: #b25a0b;
      font-size: rem(28px);
    }
  }
  ul {
    padding: 0 rem(34px);
    margin-bottom: rem(25px);
  }
  li {
    @include setBottomLine(#dad2cf);
    padding-bottom: rem(16px);
    margin-bottom: rem(25px);
    &:last-child {
      margin-bottom: 0;
      padding-bottom: rem(14px);
      &::after {
        display: none;
      }
    }
  }
  .u-info {
    color: #5e4732;
    flex: 1;
    img {
      width: rem(80px);
      height: rem(80px);
      border: rem(3px) solid #fda906;
      border-radius: 50%;
      margin-right: rem(24px);
    }
    .u-info__number {
      font-size: rem(26px);
      line-height: rem(37px);
    }
    time {
      margin-top: rem(6px);
      line-height: rem(33px);
      font-size: rem(24px);
    }
  }
  .u-logined,
  .u-vip {
    flex: 1;
    color: #5e4732;
    font-size: rem(26px);
    line-height: rem(37px);
    text-align: right;
    b {
      margin-top: rem(6px);
      line-height: rem(33px);
      font-size: rem(24px);
    }
  }
  .waiting-icon {
    @include bg-image(
      "https://cdncos.aigupiao.com/assets/wap/img/hd/invite_cash_back/waiting_icon",
      "png"
    );
  }
  .invalid-icon {
    @include bg-image(
      "https://cdncos.aigupiao.com/assets/wap/img/hd/invite_cash_back/invalid_icon",
      "png"
    );
  }
  .u-state {
    color: #a48b83;
    font-size: rem(24px);
    line-height: rem(33px);
    margin-top: rem(15px);
    background-position: left center;
    background-size: rem(20px) rem(20px);
    padding-left: rem(26px);
  }
  .more {
    line-height: rem(72px);
    font-size: rem(26px);
    color: #fff;
    background: #fda906;
    text-align: center;
    .mark {
      display: inline-block;
      width: 0;
      height: 0;
      vertical-align: middle;
      margin-left: rem(10px);
      border-top: rem(10px) solid transparent;
      border-left: rem(10px) solid #fff;
      border-bottom: rem(10px) solid transparent;
    }
  }
}

.gray-yellow-color {
  color: #a48b83;
}

.special-color {
  color: #ff4949;
}
</style>
